export const data = [
  {
    id: "healthy",
    name: "Creating a Healthier Environment",
    image: "/assets/images/why/healthy.png",
  },
  {
    id: "reliable",
    name: "Reliable and Trustworthy",
    image: "/assets/images/why/reliable.png",
  },
  {
    id: "guarantee",
    name: "Satisfaction Guarantee",
    image: "/assets/images/why/guarantee.png",
  },
  {
    id: "experienced",
    name: "Experienced Professionals",
    image: "/assets/images/why/experienced.png",
  },
  {
    id: "scheduling",
    name: "Flexible Scheduling",
    image: "/assets/images/why/scheduling.png",
  },

  {
    id: "comprehensive",
    name: "Comprehensive Cleaning Services",
    image: "/assets/images/why/comprehensive.png",
  },

  {
    id: "rates",
    name: "Affordable Rates",
    image: "/assets/images/why/rates.png",
  },
  {
    id: "eco",
    name: "Eco-Friendly Products",
    image: "/assets/images/why/eco.png",
  },
];
